import { render, staticRenderFns } from "./MassMessage.vue?vue&type=template&id=8aadcaa2&scoped=true"
import script from "./MassMessage.vue?vue&type=script&lang=js"
export * from "./MassMessage.vue?vue&type=script&lang=js"
import style0 from "./MassMessage.vue?vue&type=style&index=0&id=8aadcaa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aadcaa2",
  null
  
)

export default component.exports